export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/theft.af653636.svg","height":165,"width":165,"blurWidth":0,"blurHeight":0};